import { render, staticRenderFns } from "./StreamChat.vue?vue&type=template&id=460e8727&scoped=true&"
import script from "./StreamChat.vue?vue&type=script&lang=js&"
export * from "./StreamChat.vue?vue&type=script&lang=js&"
import style0 from "./StreamChat.vue?vue&type=style&index=0&id=460e8727&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e8727",
  null
  
)

export default component.exports